import { UserContext } from 'context';
import { useContext, useMemo } from 'react';
import { ICompanyHumanResourcesUser } from 'types/Company';
import { ITutorUser } from 'types/TutorUser';

export const useUser = () => {
  const context = useContext(UserContext);

  return context;
};

export const useCompanyHumanResourcesUser = () => {
  const { user, ...context } = useContext(UserContext);
  const companyUser = user as ICompanyHumanResourcesUser;

  return {
    ...context,
    user: companyUser,
    isSuperUser: companyUser?.isSuperUser,
  };
};

export const useTutorUser = () => {
  const { user, ...context } = useContext(UserContext);
  const tutorUser = user as unknown as ITutorUser;

  const planSubscription = useMemo(() => {
    if (!tutorUser?.plan?.length) {
      return null;
    }

    // Get last plan subscription
    const lastSubscription = tutorUser.plan[tutorUser.plan.length - 1];

    return lastSubscription;
  }, [tutorUser?.plan]);

  return {
    ...context,
    user: tutorUser,
    planSubscription,
    hasPlanSubscription: Boolean(planSubscription?.active),
  };
};
